import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { NAKED_NEWS_LIVE_SCHEDULE } from '../../constants/apiUrls/apiUrls';
import defaultImage from '../../assets/modal/FanZone-Generic.jpg';
import callApi from '../../utils/callApi';

import styles from './css/NNLiveSchedule.module.css';


const ONE_MIN_IN_MILLIS = 60000;

function NNLiveSchedule(props) {
  const [data, setData] = useState([]);

  const setScheduleData = () => {
    callApi(NAKED_NEWS_LIVE_SCHEDULE, 'get').
      then((res) => {
        setData(res.data);
        props.setNakedNewsLivePageAd(res.data[0]);
      }).
      catch(() =>
        setData([])
      );
  };

  useEffect(() => {
    setScheduleData();
    const interval = setInterval(() => {
      setScheduleData();
    }, ONE_MIN_IN_MILLIS);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.nakedNewsLiveBio}>
      <div className={styles.leftHeader}>
        Upcoming Live Shows
      </div>
      <div className={styles.scheduleNakedNewsLive}>
        <ul className={styles.scheduleList}>
          {
            data.map((val) => (
              <li
                key={val.dateOfEvent.toString()}
                className={styles.scheduleListItem}
              >
                <a
                  className={styles.scheduledProfileImg}
                  href={val.profileUrl}
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    alt={val.name}
                    src={val.image || val.fallbackImage || defaultImage}
                  />
                </a>
                <div className={styles.scheduledInfo}>
                  <div className={styles.temptationName} title={val.name || val.nickname}>
                    {val.name || val.nickname}
                  </div>
                  <div className={styles.date}>
                    {`${moment(val.dateOfEvent).format('ddd MMM DD hh:mm A')} ${val.timezone}`}
                  </div>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export default NNLiveSchedule;
